module.exports = __webpack_public_path__ + "img/1.1c160a46.png";